import {
  BoatLocation,
  DomesticV2MeInsurersGet200ResponseInsurersInner,
  DomesticV2MeInsurersGet200ResponseInsurersInnerDeniedEnum,
} from 'swagger/models';

import { UseMutationResult, useMutation, UseMutationOptions, MutationFunction } from 'react-query';

export const isOwnerExcludedFromBuoyInsurance = (insurers: Array<DomesticV2MeInsurersGet200ResponseInsurersInner>) =>
  insurers?.some(
    (insurer) =>
      insurer.name === 'buoy' && insurer.denied === DomesticV2MeInsurersGet200ResponseInsurersInnerDeniedEnum.owner
  );
export const useSyncMutation = <TData = unknown, TError = unknown, TVariables = void, TContext = unknown>(
  mutationFn: MutationFunction<TData, TVariables>,
  options?: Omit<UseMutationOptions<TData, TError, TVariables, TContext>, 'mutationKey'>
): UseMutationResult<TData, TError, TVariables, TContext> => {
  const mutationResults = useMutation(mutationFn, options);

  return {
    ...mutationResults,
    mutate: (...params: [TVariables]) => {
      if (!mutationResults.isLoading) {
        mutationResults.mutate(...params);
      }
    },
  };
};

/**
 * There are two API requests that happen in the above component, one that
 * returns an Address type and the other returns a BoatLocation type. The
 * BoatLocation type has some extra information. We check for that here to
 * satisfy TS.
 */
export const isBoatLocationType = (location: unknown): location is BoatLocation => {
  if (typeof location !== 'object' || location === null) return false;

  // uuid is on the Address type and does not exist on the BoatLocation type
  if ('uuid' in location) return false;

  const hasBoatLocationProperties =
    'location_type' in location || 'location_name' in location || 'full_address' in location;

  return hasBoatLocationProperties;
};
